import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core'
import { MatButton } from '@angular/material/button'
import { MatTableDataSource, MatTableModule } from '@angular/material/table'
import { JsonPipe, NgClass, NgIf } from '@angular/common'
import { MatIcon } from '@angular/material/icon'
import { CnpjPipe } from '../../pipes/cpnj.pipes'
import { CpfPipe } from '../../pipes/cpf.pipes'
import { TelefonePipe } from '../../pipes/phone.pipes'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { MatTooltip } from '@angular/material/tooltip'

@Component({
  selector: 'table-list-disassociated-sub-client',
  imports: [
    MatButton,
    MatTableModule,
    MatIcon,
    NgIf,
    CnpjPipe,
    CpfPipe,
    TelefonePipe,
    MatProgressSpinner,
    MatTooltip,
    JsonPipe,
    NgClass,
  ],
  templateUrl: './table-list-disassociated-sub-client.component.html',
  styleUrl: './table-list-disassociated-sub-client.component.scss',
})
export class TableListDisassociatedSubClientComponent
  implements OnInit, OnChanges
{
  constructor() {}

  @Input() dataSource: any[] = []
  @Input() columns: any[] = []
  @Input() listAssociateClient: number[] = []
  @Input() loading = false
  @Input() listClient = false

  @Output() selectItem = new EventEmitter<any>()
  @Output() removeItemEvent = new EventEmitter<any>()
  @Output() addItemEvent = new EventEmitter<any>()

  displayedColumns: string[] = []
  tableSource = new MatTableDataSource<any>()

  ngOnInit() {
    if (this.dataSource.length > 0) {
      this.displayedColumns = this.columns.map((obj: any) => obj.keyColumn)
      this.tableSource = new MatTableDataSource<any>(this.dataSource)
      this.updateTableDataSource()
    }
  }

  ngOnChanges() {
    this.updateTableDataSource()
  }

  private updateTableDataSource() {
    this.tableSource.data = this.dataSource
  }

  selectItemEvent(item: any): void {
    this.selectItem.emit(item)
  }

  removeItem(item: any): void {
    this.removeItemEvent.emit(item)
  }

  addItem(item: any): void {
    this.addItemEvent.emit(item)
  }

  checkRow(row: any) {
    const index = this.listAssociateClient.findIndex((ele) => {
      return ele == row.id
    })
    return index == -1 ? true : false
  }
}
